import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import useProduct from '../useProduct';
import { DynamicComponent } from '../..';
import AwardsIcons from './AwardsIcons';

export default function Awards({ product: data, style }) {
  const product = useProduct(data);
  if (!hasContent(product)) return null;

  return (
    <DynamicComponent.Wrapper style={style}>
      <DynamicComponent.Label style={{ marginBottom: 8 }}>
        <Trans>Awards</Trans>
      </DynamicComponent.Label>
      <AwardsIcons product={product} />
    </DynamicComponent.Wrapper>
  );
}

Awards.hasContent = hasContent;

function hasContent({ awards = [] }) {
  return awards?.length > 0;
}
Awards.fragment = gql`
  fragment Awards on Product {
    awards {
      award
      awardCode: award(format: RAW)
      medal
      medalCode: medal(format: RAW)
    }
  }
`;
